const saveFilterToLocalStorage = (authorizedUserId,  newFilters, filtersType) => {
  // localStorage.removeItem(authorizedUserId)
  const storagedData = JSON.parse(localStorage.getItem(authorizedUserId));
  const dataToSave = {...storagedData, [filtersType]: newFilters}
  localStorage.setItem(authorizedUserId, JSON.stringify(dataToSave))
  // const storagedData1 = JSON.parse(localStorage.getItem(authorizedUserId));
  // console.log(storagedData1)
}

export default saveFilterToLocalStorage;